import { ThemeUICSSObject } from 'theme-ui';
import merge from 'lodash-es/merge';
import buildStateObject from './buildStateObject';
import getColorsByPath from './getColorsByPath';
// import buildColorsObject from './buildColorsObject';
// import getColorState from './getColorState';

export interface TGetColorsAndStatesOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mergeObject?: Record<string, any>;
  states?: {
    active?: boolean;
    checked?: boolean;
    default?: boolean;
    disabled?: boolean;
    focus?: boolean;
    hover?: boolean;
    readonly?: boolean;
    path?: boolean;
    selected?: boolean;
  };
}

/**
 * Esta función es útil para devolver los estados calculados por la aplicación
 * dentro del objeto colors de ThemeUI. Si se desea calcular los estados en
 * base a un color, se debe utilizar el método getColorsAndStatesByColor.
 */
export default function getColorsAndStatesByPath(
  incomingPath: string,
  options?: TGetColorsAndStatesOptions,
) {
  const active = getColorsByPath(`${incomingPath}.active`, options);
  const checked = getColorsByPath(`${incomingPath}.checked`, options);
  const disabled = {
    cursor: 'not-allowed',
    ...getColorsByPath(`${incomingPath}.disabled`, options),
  };
  const hover = getColorsByPath(`${incomingPath}.hover`, options);
  const focus =
    options?.states?.focus !== false
      ? getColorsByPath(`${incomingPath}.focus`, options)
      : {};
  const readonly = {
    cursor: 'notAllowed',
    ...getColorsByPath(`${incomingPath}.readonly`, options),
  };
  const selected = getColorsByPath(`${incomingPath}.selected`, options);

  return merge(
    {
      ...(options?.states?.default !== false
        ? getColorsByPath(incomingPath, options)
        : null),
      ...(options?.states?.checked !== false
        ? buildStateObject(checked, 'checked')
        : null),
      ...buildStateObject(focus, 'focus'),
      ...(options?.states?.hover !== false
        ? buildStateObject(hover, 'hover')
        : null),
      ...(options?.states?.selected !== false
        ? buildStateObject(selected, 'selected')
        : null),
      ...(options?.states?.active !== false
        ? buildStateObject(active, 'active')
        : null),
      ...(options?.states?.disabled !== false
        ? buildStateObject(disabled, 'disabled')
        : null),
      ...(options?.states?.readonly !== false
        ? buildStateObject(readonly, 'readonly')
        : null),
      ...(options?.states?.path !== false
        ? { path: { fill: `currentColor` } }
        : null),
    },
    options?.mergeObject,
  ) as Record<string, ThemeUICSSObject>;
}
